import { render } from "./rates.vue?vue&type=template&id=7e15e8f4&scoped=true"
import script from "./rates.vue?vue&type=script&lang=js"
export * from "./rates.vue?vue&type=script&lang=js"

import "./rates.vue?vue&type=style&index=0&id=7e15e8f4&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e15e8f4"]])

export default __exports__